import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import '../styles/LandingPage.css';
import { useAuth } from '../hooks/useAuth';

const MedicalAssessmentsDashboard = () => {
  const { rolePermissions } = useAuth();

  function MyLink(props) {
    if (rolePermissions[props.path]?.View === 'true') {
      return (
        <Link to={props.path} className="link-card">
          <FontAwesomeIcon icon={props.iconname} size="3x" className="icon" />
          <p>{props.name}</p>
        </Link>
      );
    }

    return null;
  }

  return (
    <div className="landing-page">
      <div className="links-container">
        <MyLink path="/medical-contract-list" iconname={faFileInvoiceDollar} name="Medical Contract List" />
        <MyLink path="/medical-exam-export" iconname={faBoxArchive} name="Medical Exam Export" />
      </div>
    </div>
  );
};

export default MedicalAssessmentsDashboard;